<template>
	<div class="content">
		<div class="content_head">
			<p><input type="text" @keypress="pageIndex=1;getData()" placeholder="会员手机号|会员姓名" class="search"
					v-model="searchText" />
				<button type="button" class="button" @click="getData()">查询</button>
			</p>
		</div>
		<div class="content_body">
			<table>
				<thead>
					<tr>
						<th>序号</th>
						<th>订单信息</th>
						<th>借书详情</th>
						<th>运费</th>
						<th>配送地址</th>
						<th>处理店铺</th>
						<th>订单状态</th>
						<th>配书</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(i,index) in orders">
						<td>
							{{index+1}}
						</td>
						<td style="text-align: left;">
							订单时间:<span class="red"> {{i.OrderDate}}</span><br />
							订单类型:<span class="red"> {{i.OrderType==3?'微信还书单':'微信借书单'}}</span><br />
							客户编号:<span class="red"> {{i.OrderCode}}</span><br />
							客户姓名:<span class="red">{{i.CustomerName}}</span><br />
							联系方式:<span class="red">{{i.CustomerPhone}}</span><br />
							客户归属:<span class="red">{{i.shopName}}</span>
						</td>

						<td style="text-align: right;">
							<p v-for='j in i.books'>
								<span class="red"> {{j.BooksName + "-"+ j.BooksCount+"本"}}</span>
							</p>
						</td>

						<td>
							<p>应付: <span class="red">{{i.FreightMoney}}¥</span></p>

							<p> 实付: <span class="red">{{i.ActualPayment}}¥</span></p>
						</td>
						<td>
							{{i.Destination}}

						</td>
						<td>
							{{i.shopName}}
							<br>
							{{i.Transporter}}

						</td>
						<td>
							<span class="red">{{i.OrderState==2 && i.OrderType==3?"取回中":"配送中"}}</span>
						</td>
						<td>
							<button type="button" class="button" @click="setOrder(i.CustomerOrderID)"> 图书详情 </button>
							<br />
							<button type="button" class="button" @click="customerOrderSend(i)">
								{{i.OrderType==3?'取回完成':'配送完成'}} </button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="foot_pages">
			<button class="button" :class="{'disabled':up}" :disabled="up" @click="changePages('up')">上一页</button>
			<span>{{page}}</span>

			<select v-model="pageRows" @change="changePageRows">
				<option value="10">10/页</option>
				<option value="20">20/页</option>
				<option value="30">30/页</option>

			</select>
			<button class="button" :class="{'disabled':down}" :disabled="down" @click="changePages('down')">下一页</button>
		</div>
	</div>


</template>

<script>
	import j from './index.js'
	export default j
</script>

<style>
</style>
